export enum NOTIFICATIONS_ACTIONS_TYPES {
    INITIAL_REQUEST = 'INITIAL_REQUEST',
    LAZY_LOADING_REQUEST = 'LAZY_LOADING_REQUEST',
}
